import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@chatterbug/aaron'

const STYLES = {
  justifyContent: 'flex-start',
  width: '100%',
  backgroundColor: 'transparent',
  py: '1x',
  px: '2x',
  borderRadius: '40px',
  borderWidth: '0',
  fontSize: 'xs',
  color: 'black19',
  ':hover, :active, :focus': {
    backgroundColor: 'gray95',
  },
}

const LINK_OVERRIDES = {
  ':hover, :active, :focus': {
    backgroundColor: 'gray95',
    color: 'black19',
    textDecoration: 'none',
  },
}

const AsButton = ({ onClick, title, destructive }) => {
  return (
    <Flex
      as="button"
      onClick={onClick}
      sx={{ ...STYLES, color: destructive && 'red44' }}
    >
      {title}
    </Flex>
  )
}

const AsLink = ({ href, title }) => {
  return (
    <Flex as="a" href={href} sx={{ ...STYLES, ...LINK_OVERRIDES }}>
      {title}
    </Flex>
  )
}

const OptionItem = ({ href, handleClick, title, destructive, id }) => {
  if (handleClick) {
    return (
      <AsButton
        onClick={() => handleClick(id)}
        title={title}
        destructive={destructive}
      />
    )
  }
  if (href) {
    return <AsLink href={href} title={title} />
  }

  return null
}

OptionItem.propTypes = {
  href: PropTypes.string,
  handleClick: PropTypes.func,
  title: PropTypes.string,
  destructive: PropTypes.bool,
  id: PropTypes.number,
}

export default OptionItem
